import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Custom hook for user manager dashboard navigation
 * Handles URL-based tab management and routing for USER_MANAGER role
 */
export const useUserManagerNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // URL-based tab management for user manager
  const getActiveTabFromUrl = () => {
    const path = location.pathname;
    if (path === '/user-manager/users') return 'users';
    if (path === '/user-manager/user-approvals') return 'user-approvals';
    if (path === '/user-manager/subscriptions') return 'subscriptions';
    return 'overview'; // default for /user-manager/dashboard
  };
  
  const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());
  
  // URL synchronization effect
  useEffect(() => {
    const tabFromUrl = getActiveTabFromUrl();
    if (tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [location.pathname, activeTab]);
  
  // Tab navigation function for user manager
  const handleTabChange = (tab) => {
    const routeMap = {
      'overview': '/user-manager/dashboard',
      'users': '/user-manager/users',
      'user-approvals': '/user-manager/user-approvals',
      'subscriptions': '/user-manager/subscriptions'
    };
    navigate(routeMap[tab] || '/user-manager/dashboard');
  };
  
  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('token');
    navigate('/login');
  };
  
  return {
    activeTab,
    handleTabChange,
    handleLogout
  };
};